module.exports = __webpack_public_path__ + "static/media/userPageIcon.8c845481.svg";